// The inquiry funnel — single source of truth for stage order, labels and colors
// (board columns, list filters, detail select, dashboard pipeline, card badges).
// Mirrors Inquiry::FUNNEL_STATES on the backend.

export const FUNNEL = [
  { state: "pending", label: "Nueva", hint: "sin responder", color: "#e0892f", bg: "#fdeecf", fg: "#8a5a00" },
  { state: "ongoing", label: "En contacto", color: "#2353b8", bg: "#e1ecff", fg: "#2353b8" },
  { state: "on_hold", label: "Seguimiento", color: "#6a3a8f", bg: "#efe3f7", fg: "#6a3a8f" },
  { state: "visit", label: "Visita", color: "#0e7490", bg: "#e0f4f8", fg: "#0e7490" },
  { state: "negotiation", label: "Negociación", color: "#b45309", bg: "#fdeed3", fg: "#92400e" },
  { state: "success", label: "Ganada", terminal: true, color: "#2c6e49", bg: "#e3f3e8", fg: "#2c6e49" },
  { state: "lost", label: "Perdida", terminal: true, color: "#8a8378", bg: "#ece9e3", fg: "#6a645a" }
];

export const STATE_LABELS = FUNNEL.reduce((acc, s) => {
  acc[s.state] = s.label;
  return acc;
}, { watching: "Seguimiento" }); // stragglers pre-merge

export const LOST_REASONS = [
  { value: "no_responde", label: "No responde" },
  { value: "eligio_otra", label: "Eligió otra propiedad" },
  { value: "precio", label: "Precio" },
  { value: "financiacion", label: "Financiación" },
  { value: "no_disponible", label: "Propiedad no disponible" },
  { value: "sin_interes", label: "Sin interés" },
  { value: "otro", label: "Otro" }
];

export const lostReasonLabel = value => {
  const r = LOST_REASONS.find(x => x.value === value);
  return r ? r.label : value;
};
